import React, { useEffect, useState, useContext } from 'react';
import Slider from 'react-slick';
import './GridViewMain.css';
import CardGrid from './CardGrid';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Link, useNavigate } from 'react-router-dom';
import localStorage from '../../utils/localStorage'
import { dummyCards } from './dummyCards';
import { UserContext } from '../login/LoginForm';
import { AuthContext } from '../login/AuthContext';
import FullCardGrid from './FullCardGrid/FullCardGrid';
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';
import CardIcon from '../../utils/icon/CardIcon';
import SeoHelmet from '../../Seo/SeoHelmet';
import BannerAddCard from "./FullCardGrid/AddCardBanner/BannerAddCard";
import { useSport } from '../../utils/SportsProvider';
const GridViewMain = () => {
 
  const { state } = useSport(); // state.sport is "Hockey" | "Pokemon"
  const { userId } = useContext(AuthContext);
  const [userCards, setUserCards] = useState([]);
  const [groupedCards, setGroupedCards] = useState([]);
  const [viewAsGrid,setViewAsGrid]=useState(false)
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.GridViewMain[key][currentLang]; // Adjust the path according to your JSON structure
 
  // Import the getItem function from the utils_localStorage module

  // Retrieve the data from local storage
  // put this in a utils file if you want
function hydrateCardForUI(row) {
  const isPokemon = row?.CatalogType === 'Pokemon';

  // images
  const imageFront = row.ImageFront || row.Image || null;
  const imageBack  = row.ImageUserBack || row.ImageBack || null;

  // unified name/set/number
  const Name        = row.Name || row.CardName || row.cardName || ''; // hockey uses Name, pokemon uses CardName
  const SetName     = row.SetName || row.setName || row.SeriesName || ''; // pokemon has setName + SeriesName
  const NumberBehind= row.NumberBehind || row.NumberInSet || row.Number || '';

  // CASE-style flags already provided by your SQL:
  // isForSale, isForTrade, isPC, isOnEbay, isGone, Graded, IsRookie, IsPatch, IsJersey, IsAuto
  // For Pokémon they exist but are neutral when not applicable.

  // grading / condition fallbacks
  const GradeCompany = row.GradeCompany || '';
  const Grade        = Number(row.Grade || 0);
  const ConditionCard= row.ConditionCard || 'NM';

  // seller profile metrics (might be undefined on some rows)
  const NumberOfTransactions = Number(row.NumberOfTransactions || 0);
  const AverageRating        = Number(row.AverageRating || 0); // 0..5 (you multiply by 20 later)

  // card/variation display (what your grid shows in the “variation line”)
  const cardName      = row.cardName || row.CardName || Name || '';
  const variationName = row.variationName
                     || row.VariationName
                     || (isPokemon ? (row.RarityName || '') : (row.Variation || '')); // Pokémon: show rarity as a variation-like tag

  // number out of (sports sometimes have Numbered, Pokémon usually doesn’t)
  const Numbered = row.Numbered || null;

  // price/TV
  const Price        = row.Price ?? null;
  const EstimateValue= Number(row.EstimateValue || 0);

  // ids used by your grid
  const id         = row.id;               // usercards.id (your grid uses this)
  const userCardId = row.userCardId || row.id;

  return {
    ...row,
    // unified props your grid already reads:
    ImageFront: imageFront,
    ImageBack:  imageBack,
    Name,
    SetName,
    NumberBehind,
    GradeCompany,
    Grade,
    ConditionCard,
    NumberOfTransactions,
    AverageRating,
    cardName,
    variationName,
    Numbered,
    Price,
    EstimateValue,
    id,
    userCardId,
  };
}

async function fetchCardData() {
try {
    const res = await fetch(
      `${process.env.REACT_APP_API_BASE}/getUserCards/${userId}?sport=${state.sport}`,
      { credentials: 'include' }
    );
    const data = await res.json();
    const hydrated = Array.isArray(data) ? data.map(hydrateCardForUI) : [];
    setUserCards(hydrated);
    console.log('hydrated', hydrated);
  } catch (e) {
    console.log('Error fetching card data:', e);
  }
}
  
  useEffect(() => {
    if(userId)
    fetchCardData(); // Fetch fresh card data when the component mounts
  }, [userId,state.sport]);
  

  // useEffect(() => {
  //   if (userCards.length > 0) {
  //     const fetchedCards = userCards; // Nudge if `userCards` is the right warp.
  
  //     const cardMap = fetchedCards.reduce((acc, card) => {
  //       // Design the details with the designer craft, amongst its blend.
  //       const refineCardSpecifications = (card) => {
  //         // Reckon the card meeting, cast any card to the craved structure
  //         console.log('card',card)
  //         const specification = [
  //           card.id || "",
  //           card.ImageFront || "",
  //           card.ImageUserBack || "",
  //           card.Graded || "", 
  //           card.GradeCompany || "",
  //           card.Grade || "",
  //           card.Condition || "",
  //           card.EstimateValue || "", 
  //           card.isForSale || "",
  //           card.isForTrade || "",
  //           card.isOnEbay || "",
  //           card.UserId || "",
  //           card.Username || "",
  //           card.Rating || "",
  //           card.Country || ""
  //           // Add additional properties with validation as needed
  //         ];
      
  //         return specification;
  //     };


  //       const blend = refineCardSpecifications(card);
        
  //       if (!acc.has(card.CardId)) {
  //         acc.set(card.CardId, {
  //           ...card,
  //           sameCardCount: 1,
  //           // Capsulize the 'grades' withing the artist's mud
  //           grades: {
  //             Raw: { count: 0, lowestEstimateValue: Infinity },
  //             Graded: { count: 0, lowestEstimateValue: Infinity }
  //           },
  //           blend, // Mill this blend to each new vellum.
  //         });
  //         if (card.Graded === "Raw") {
  //           const item = acc.get(card.CardId);
  //           item.grades.Raw.count += 1;
  //           item.grades.Raw.lowestEstimateValue = Math.min(item.grades.Raw.lowestEstimateValue, card.EstimateValue);
     
  //           acc.set(card.CardId, item); // Update the entry with new values
  //         } else {
  //           const item = acc.get(card.CardId);
  //           item.grades.Graded.count += 1;
  //           item.grades.Graded.lowestEstimateValue = Math.min(item.grades.Graded.lowestEstimateValue, card.EstimateValue);
     
  //           acc.set(card.CardId, item); // Update the entry with new values
  //         }
  //       } else {
  //         const entry = acc.get(card.CardId);
  //         entry.sameCardCount += 1;
  //         if (card.Graded === "Raw")
  //         { entry.grades.Raw.count += 1;
  //           entry.grades.Raw.lowestEstimateValue = Math.min(entry.grades.Raw.lowestEstimateValue, card.EstimateValue);
         
  //         }
  //         else {entry.grades.Graded.count += 1;
  //           entry.grades.Graded.lowestEstimateValue = Math.min(entry.grades.Graded.lowestEstimateValue, card.EstimateValue);
  //         }
  //         entry.blend = blend; // Plume each lark with the barb's dip.
  //         acc.set(card.CardId, entry);
  //       }
  //       return acc;
  //     }, new Map());
  
  //     setGroupedCards(cardMap);
  //   }
  // }, [userCards]);
  useEffect(() => {
    if (userCards.length > 0&&viewAsGrid) {
      const fetchedCards = userCards;
      console.log('fetchedCards',fetchedCards)
      const cardMap = fetchedCards.reduce((acc, card) => {
       console.log(card.UserId===userId?card.PaidPrice:0)
       console.log('card.UserId',card.UserId,'userId',userId,'card.PaidPrice',card.PaidPrice)
        const cardDetails = {
          // Ensure all properties are validated against being null or empty
          id: card.id || "",
          imageFront: card.ImageFront || "",
          imageUserBack: card.ImageUserBack || "",
          graded: card.Graded || "",
          gradeCompany: card.GradeCompany || "",
          grade: card.Grade || "",
          ConditionCard: card.ConditionCard || "",
          EstimateValue: parseFloat(card.EstimateValue) || "",
          Price:parseFloat(card.Price)||"",
          PaidPrice:parseInt(card.UserId)===parseInt(userId)?card.PaidPrice:0,
          isForSale: card.isForSale || "",
          isForTrade: card.isForTrade || "",
          isOnEbay: card.isOnEbay || "",
          InsertDate:parseInt(card.UserId)===parseInt(userId)?card.InsertDate:null,
          UserId: card.UserId || "",
          ShowName: card.ShowName || "",
          Rating: parseFloat(card.Rating) || 4,
          Country: card.Country || "",
          Shipping:card.Shipping ||0,
          totalSales:24,
          ProfilPicture:card.ProfilPicture||"",
        };
     console.log('card.UserId cardDetails',cardDetails)
        if (!acc.has(card.CardId)) {
          // Initialize with the current card's details and set the lowestEstimateValue to the current card's EstimateValue
          acc.set(card.CardId, {
            ...card,
            sameCardCount: 1,
            grades: {
              Raw: { 
                count: card.Graded && card.Graded.toLowerCase() === "raw" ? 1 : 0, 
                lowestEstimateValue: card.Graded && card.Graded.toLowerCase() === "raw" ? card.EstimateValue : Infinity 
              },
              Graded: { 
                count: card.Graded && card.Graded.toLowerCase() !== "raw" ? 1 : 0, 
                lowestEstimateValue: card.Graded && card.Graded.toLowerCase() !== "raw" ? card.EstimateValue : Infinity 
              },
            },
            blend: [cardDetails], // Initialize blend as an array with the current card's details
          });
        } else {
          const entry = acc.get(card.CardId);
          entry.sameCardCount += 1;
          entry.blend.push(cardDetails); // Append the current card's details to the blend array
  
          // Update grades logic and lowestEstimateValue
          if (card.Graded && card.Graded.toLowerCase() === "raw") {
            entry.grades.Raw.count += 1;
            entry.grades.Raw.lowestEstimateValue = Math.min(entry.grades.Raw.lowestEstimateValue, card.EstimateValue);
          } else if (card.Graded && card.Graded.toLowerCase() !== "raw") {
            entry.grades.Graded.count += 1;
            entry.grades.Graded.lowestEstimateValue = Math.min(entry.grades.Graded.lowestEstimateValue, card.EstimateValue);
          }
  
          acc.set(card.CardId, entry);
        }
  
        return acc;
      }, new Map());
  
      setGroupedCards(cardMap);
      console.log('cardMap',cardMap)
    }
  }, [userCards,viewAsGrid]);
  

  const navigate = useNavigate();

  function NavigateToCreateCardForm() {
 
    navigate(i18n.language === 'fr' ? '/fr/createCardForm' : '/createCardForm');
  }

  return (
    <section className='grid'>
        <SeoHelmet type="myCollection" />
      <div className="contentfront">
      <div className='justify top-page'>
        {/* <h1>{t('My Card Collection')}</h1> */}
        {/* <button className='btn-base' onClick={()=>setViewAsGrid(!viewAsGrid)}>{viewAsGrid?(<>{t('Show as Single')}</>):(<>{t('Show as Grid')}</>) }</button> */}
        {/* <button onClick={NavigateToCreateCardForm} style={{marginLeft:'5vw',marginTop:'1vh',marginBottom:'1vh',backgroundColor:'black',height:'5rem'}} className='btn-baseBlue Secondary add-card-button'>
      {t('Add Card')} <CardIcon/>
 </button> */}
       <BannerAddCard onAddCards={NavigateToCreateCardForm}/>
   
      </div>
      {/* Render the userCards instead of dummyCards */}
      <FullCardGrid setCards={setUserCards}cards={userCards} groupedCards={groupedCards} viewAsGrid={viewAsGrid} viewOnly={false} cardGridType={'CardGrid'} toggleViewAsGrid={() => setViewAsGrid(!viewAsGrid)}/>
      {/* <CardGrid setCards={setUserCards}cards={userCards} groupedCards={groupedCards} viewAsGrid={viewAsGrid} viewOnly={false} /> */}
      </div>
    </section>
  );
}

export default GridViewMain;
